import { userConstants } from '../constants';

function getMeta (state = {}, action) {
  switch (action.type) {
    case userConstants.GET_META_DATA_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_META_DATA_SUCCESS:
      return {
        loading: false,
        ...action,
      };
    case userConstants.GET_META_DATA_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

function getHome (state = {}, action) {
  switch (action.type) {
    case userConstants.GET_HOME_DATA_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_HOME_DATA_SUCCESS:
      return {
        loading: false,
        items: action,
      };
    case userConstants.GET_HOME_DATA_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

function getAboutData (state = {}, action) {
  switch (action.type) {
    case userConstants.GET_ABOUT_DATA_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_ABOUT_DATA_SUCCESS:
      return {
        loading: false,
        items: action.res,
      };
    case userConstants.GET_ABOUT_DATA_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

function getConcerts (state = {}, action) {
  switch (action.type) {
    case userConstants.GET_CONCERTS_DATA_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_CONCERTS_DATA_SUCCESS:
      return {
        loading: false,
        items: action.res,
      };
    case userConstants.GET_CONCERTS_DATA_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

function getPastConcerts (state = {}, action) {
  switch (action.type) {
    case userConstants.GET_PAST_CONCERTS_DATA_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_PAST_CONCERTS_DATA_SUCCESS:
      return {
        loading: false,
        items: action.res,
      };
    case userConstants.GET_PAST_CONCERTS_DATA_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

function getConcert (state = {}, action) {
  switch (action.type) {
    case userConstants.GET_CONCERT_DATA_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_CONCERT_DATA_SUCCESS:
      return {
        loading: false,
        items: action.res,
      };
    case userConstants.GET_CONCERT_DATA_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

function getArtists (state = {}, action) {
  switch (action.type) {
    case userConstants.GET_ARTISTS_DATA_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_ARTISTS_DATA_SUCCESS:
      return {
        loading: false,
        items: action.res,
      };
    case userConstants.GET_ARTISTS_DATA_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

function getFAQ (state = {}, action) {
  switch (action.type) {
    case userConstants.GET_FAQ_DATA_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_FAQ_DATA_SUCCESS:
      return {
        loading: false,
        items: action,
      };
    case userConstants.GET_FAQ_DATA_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

function getUsefulContacts (state = {}, action) {
  switch (action.type) {
    case userConstants.GET_USEFULCONTACTS_DATA_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_USEFULCONTACTS_DATA_SUCCESS:
      return {
        loading: false,
        items: action.res,
      };
    case userConstants.GET_USEFULCONTACTS_DATA_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

function getSettingsData (state = {}, action) {
  switch (action.type) {
    case userConstants.GET_SETTINGS_DATA_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_SETTINGS_DATA_SUCCESS:
      return {
        loading: false,
        items: action.res,
      };
    case userConstants.GET_SETTINGS_DATA_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

function getSponsors (state = {}, action) {
  switch (action.type) {
    case userConstants.GET_SPONSORS_DATA_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_SPONSORS_DATA_SUCCESS:
      return {
        loading: false,
        items: action.res,
      };
    case userConstants.GET_SPONSORS_DATA_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

function getNewsListing (state = {}, action) {
  switch (action.type) {
    case userConstants.GET_NEWS_LISTING_DATA_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_NEWS_LISTING_DATA_SUCCESS:
      return {
        loading: false,
        items: action,
      };
    case userConstants.GET_NEWS_LISTING_DATA_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

function getNews (state = {}, action) {
  switch (action.type) {
    case userConstants.GET_NEWS_DATA_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_NEWS_DATA_SUCCESS:
      return {
        loading: false,
        items: action.res,
      };
    case userConstants.GET_NEWS_DATA_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

function getPress (state = {}, action) {
  switch (action.type) {
    case userConstants.GET_PRESS_DATA_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_PRESS_DATA_SUCCESS:
      return {
        loading: false,
        items: action,
      };
    case userConstants.GET_PRESS_DATA_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

function getPressInner (state = {}, action) {
  switch (action.type) {
    case userConstants.GET_PRESS_INNER_DATA_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_PRESS_INNER_DATA_SUCCESS:
      return {
        loading: false,
        items: action.res,
      };
    case userConstants.GET_PRESS_INNER_DATA_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

function getContactData (state = {}, action) {
  switch (action.type) {
    case userConstants.GET_CONTACTS_DATA_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_CONTACTS_DATA_SUCCESS:
      return {
        loading: false,
        items: action.res,
      };
    case userConstants.GET_CONTACTS_DATA_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

function getDonationData (state = {}, action) {
  switch (action.type) {
    case userConstants.GET_DONATION_DATA_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_DONATION_DATA_SUCCESS:
      return {
        loading: false,
        items: action.res,
      };
    case userConstants.GET_DONATION_DATA_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

function getPressFormData (state = {}, action) {
  switch (action.type) {
    case userConstants.GET_PRESSFORM_DATA_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_PRESSFORM_DATA_SUCCESS:
      return {
        loading: false,
        items: action.res,
      };
    case userConstants.GET_PRESSFORM_DATA_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function getSearchResults (state = {}, action) {
  switch (action.type) {
    case userConstants.GET_SEARCH_RESULTS_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_SEARCH_RESULTS_SUCCESS:
      return {
        loading: false,
        items: action.res,
      };
    case userConstants.GET_SEARCH_RESULTS_ERROR:
      return {
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
}

export {
  getMeta,
  getHome,
  getConcerts,
  getPastConcerts,
  getConcert,
  getArtists,
  getNewsListing,
  getNews,
  getPress,
  getAboutData,
  getFAQ,
  getUsefulContacts,
  getSponsors,
  getContactData,
  getDonationData,
  getPressFormData,
  getPressInner,
  getSettingsData
};
